import { Descriptions } from "antd";
import { FormattedMessage } from "react-intl";
import formatAmount from "utils/formatAmount";
import formatDateTimeZoned from "utils/formatDateTimeZoned";

import { OrderDescriptionProps } from "./types";

const OrderDescription: React.FC<OrderDescriptionProps> = ({
  orderNumber,
  createdAt,
  totalAmount,
  status,
  receiptUrl,
  paymentMethod,
  paymentType,
  eventName,
  eventDate,
  eventTimezone,
  discountCode,
}) => (
  <Descriptions bordered column={1}>
    <Descriptions.Item
      label={<FormattedMessage defaultMessage="Order Number" />}
    >
      {orderNumber}
    </Descriptions.Item>
    <Descriptions.Item label={<FormattedMessage defaultMessage="Order Time" />}>
      {createdAt ? formatDateTimeZoned(new Date(createdAt.toString())) : ""}
    </Descriptions.Item>
    <Descriptions.Item
      label={<FormattedMessage defaultMessage="Order Total" />}
    >
      {formatAmount(totalAmount ?? 0)}
    </Descriptions.Item>
    <Descriptions.Item
      label={<FormattedMessage defaultMessage="Customer Receipt" />}
    >
      {receiptUrl && (
        <a href={receiptUrl} target="_blank" rel="noreferrer">
          <FormattedMessage defaultMessage="Link" />
        </a>
      )}
    </Descriptions.Item>
    <Descriptions.Item
      label={<FormattedMessage defaultMessage="Payment Method" />}
    >
      {paymentMethod || paymentType}
    </Descriptions.Item>
    <Descriptions.Item label={<FormattedMessage defaultMessage="Event Name" />}>
      {eventName}
    </Descriptions.Item>
    <Descriptions.Item
      label={<FormattedMessage defaultMessage="Date and time of the event" />}
    >
      {eventDate
        ? formatDateTimeZoned(new Date(eventDate.toString()), eventTimezone)
        : ""}
    </Descriptions.Item>
    <Descriptions.Item
      label={<FormattedMessage defaultMessage="Status of the order" />}
    >
      {status}
    </Descriptions.Item>
    {discountCode && (
      <Descriptions.Item
        label={<FormattedMessage defaultMessage="Discount Code Used" />}
      >
        {discountCode.code}
      </Descriptions.Item>
    )}
  </Descriptions>
);

export default OrderDescription;
